import { AbstractEvent } from 'src/util/events/AbstractEvent';

export class NotificationEvent extends AbstractEvent {
	constructor(eventPayload: Record<string, unknown>) {
		super('GUI', 'NotificationEvent', false, false, false, eventPayload);
	}
}
